import { call, put, takeEvery } from "redux-saga/effects";

import {
  GET_JOURNAL_DAYS,
  GET_JOURNAL_BY_DAY,

  CREATE_JOURNAL_ENTRY,
  UPDATE_JOURNAL_ENTRY,
  DELETE_JOURNAL_ENTRY,
  GET_JOURNAL_TIMELINE,
} from "./actionTypes";

import {
  getJournalDaysSuccess,
  getJournalDaysFail,

  getJournalByDaySuccess,
  getJournalByDayFail,

  createJournalEntrySuccess,
  createJournalEntryFail,

  updateJournalEntrySuccess,
  updateJournalEntryFail,

  deleteJournalEntrySuccess,
  deleteJournalEntryFail,

  getJournalTimeline,
  getJournalTimelineSuccess,
  getJournalTimelineFail,
} from "./actions";

import {
  getLoggedInUser,
  getJournalDays,
  getJournalByDay,
  searchJournalNotes,
  postJournalEntry,
  putJournalEntry,
  deleteJournalEntry,
} from "helpers/fakebackend_helper";

// GET #1: list days with notes
function* fetchJournalDays() {
  try {
    const user = getLoggedInUser();
    const response = yield call(getJournalDays, user);
    yield put(getJournalDaysSuccess(response));
  } catch (error) {
    yield put(getJournalDaysFail(error));
  }
}

// GET #2: fetch notes for a day (YYYY-MM-DD)
function* fetchJournalByDay({ payload: day }) {
  try {
    const user = getLoggedInUser();
    console.log("DAY", day)
    const response = yield call(getJournalByDay, day.username, day.date);
    yield put(getJournalByDaySuccess(response));
  } catch (error) {
    yield put(getJournalByDayFail(error));
  }
}

// CREATE (network POST)
function* createEntry({ payload }) {
  try {
    const response = yield call(postJournalEntry, payload);
    yield put(createJournalEntrySuccess(response));

    // Refresh timeline so the new note is visible immediately in plant/area views
    if (payload?.username) {
      yield put(getJournalTimeline({ username: payload.username }));
    }
  } catch (error) {
    yield put(createJournalEntryFail(error));
  }
}

// UPDATE (network PUT)
function* updateEntry({ payload }) {
  try {
    const response = yield call(putJournalEntry, payload);
    yield put(updateJournalEntrySuccess(response));
    if (payload?.username) {
      yield put(getJournalTimeline({ username: payload.username }));
    }
  } catch (error) {
    yield put(updateJournalEntryFail(error));
  }
}

// DELETE (network DELETE)
function* removeEntry({ payload: noteId }) {
  try {
    yield call(deleteJournalEntry, noteId);
    yield put(deleteJournalEntrySuccess(noteId));

    // Optional refresh:
    // yield put({ type: GET_JOURNAL_DAYS })
  } catch (error) {
    yield put(deleteJournalEntryFail(error));
  }
}

// TIMELINE — search all notes for a user (optionally filtered by area/plant)
function* fetchJournalTimeline({ payload }) {
  try {
    const notes = yield call(searchJournalNotes, payload);
    yield put(getJournalTimelineSuccess(Array.isArray(notes) ? notes : []));
  } catch (error) {
    yield put(getJournalTimelineFail(error));
  }
}

export default function* journalSaga() {
  yield takeEvery(GET_JOURNAL_DAYS, fetchJournalDays);
  yield takeEvery(GET_JOURNAL_BY_DAY, fetchJournalByDay);

  yield takeEvery(CREATE_JOURNAL_ENTRY, createEntry);
  yield takeEvery(UPDATE_JOURNAL_ENTRY, updateEntry);
  yield takeEvery(DELETE_JOURNAL_ENTRY, removeEntry);
  yield takeEvery(GET_JOURNAL_TIMELINE, fetchJournalTimeline);
}
